import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "270"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "e26ohricda",
        x1: "-4.623%",
        x2: "86.992%",
        y1: "93.341%",
        y2: "20.97%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#D8E5C4",
          "stop-opacity": ".25"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#D8E5C4"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#e26ohricda)",
      "fill-rule": "evenodd",
      d: "m152.363 19.736 113.5 103.968C281.249 137.798 290 157.634 290 178.416V270h-50v-91.584a24.73 24.73 0 0 0-8.046-18.237L118.454 56.21c-9.575-8.772-24.333-8.772-33.908 0L0 133.655V66.12l50.637-46.384c28.727-26.315 72.999-26.315 101.726 0",
      transform: "matrix(-1 0 0 1 290 0)"
    }, null, -1)
  ])))
}
export default { render: render }